/* eslint-disable prettier/prettier */
const accountVerifiationErrCodeMsgMapping = errCode => {
  switch (errCode) {
    case 'AliasExistsException':
      return 'Sorry, this email cannot be verified, since this email is linked to another account.';
    case 'CodeMismatchException':
      return 'Sorry, this email cannot be verified, since the verification link is incorrect.';
    case 'LimitExceededException':
    case 'TooManyRequestsException':
      return 'Sorry, this email cannot be verified, since you have reached the request limit. Please try again later.';
    case 'TooManyFailedAttemptsException':
      return 'Sorry, this email cannot be verified, since there were too many failed attempts.';
    case 'UserNotFoundException':
      return 'Sorry, this email cannot be verified, since this email is not linked to any accounts.';
    case 'ExpiredCodeException':
      return 'Verification link is now expired, please request a new verification email.';
    case 'AccelLoginException':
      return 'Oops, something went wrong. Please call our Customer Service.';
    case 'InternalErrorException':
    case 'InternalServerError':
    case 'InvalidParameterException':
    case 'InvalidLambdaResponseException':
    case 'ResourceNotFoundException':
    case 'UnexpectedLambdaException':
    case 'UserLambdaValidationException':
    default:
      return 'Oops, something is wrong and your email is not verified. Please try again later.';
  }
};

export default accountVerifiationErrCodeMsgMapping;